import { useCallback } from 'react';
import { gql } from 'apollo-boost';
import { useMutation } from 'shared/apollo';

export const deleteServiceCollection = gql`
  mutation deleteServiceCollection(
    $id: Int!,
  ) {
  deleteCollection(
    id: $id,
  ) {
      id
      success
    }
  }
`;

export function useDeleteServiceCollection() {
  const { data, isLoading, mutate } = useMutation();
  const run = useCallback((variables, onFinish) => {
    mutate(deleteServiceCollection, variables, response => {
      if (typeof onFinish === 'function') {
        onFinish(response.deleteCollection.id);
      }
    });
  }, []);
  return { data, isLoading, run };
}
